import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="glow-ring"></div>
      <div className="loading-logo-container">
        {/* Kendi logonu buraya ekle */}
        <img src="/logo32.png" alt="Pozitif Ofis" className="loading-logo" />
      </div>
    </div>
  );
};

export default Loading;
